import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./gallery.css";
import { Link, NavLink } from "react-router-dom";
import tours from "../../../datebase/tours";
const images = [
    "img/gallery/1",
    "img/gallery/2",
    "img/gallery/3",
    "img/gallery/4",
    "img/gallery/5",
    "img/gallery/6",
    "img/gallery/7",
    "img/gallery/8",
    "img/gallery/9",
    "img/gallery/10",
    "img/gallery/11",
    "img/gallery/12",
    "img/gallery/13",
    "img/gallery/14",
    "img/gallery/15",
    "img/gallery/16",
    "img/gallery/17",
    "img/gallery/18",
    "img/gallery/19",
    "img/gallery/20",
    "img/gallery/21",
    "img/gallery/22",
    "img/gallery/23",
    "img/gallery/24",
    "img/gallery/25",
    "img/gallery/26",
    "img/gallery/27",
    "img/gallery/28",
    "img/gallery/29",
    "img/gallery/30",
    "img/gallery/31",
];
const Gallery = ({ t, langcat, setScoreTours, scoreTours }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [current, setCurrent] = useState(0);

    const openModal = (index) => {
        setCurrent(index);
        setIsOpen(true);
    };

    const next = () => {
        setCurrent((prev) => (prev + 1) % images.length);
    };

    const prev = () => {
        setCurrent((prev) => (prev - 1 + images.length) % images.length);
    };

    return (
        <>
            <div className="gallery">
                {images.map((img, index) => (
                    <img
                        key={index}
                        src={`/${img}.jpg`}
                        className={index === 2 || index === 5 ? "big" : ""}
                        onClick={() => openModal(index)}
                        alt=""
                    />
                ))}
            </div>

            {isOpen && (
                <div className="modal" onClick={() => setIsOpen(false)}>
                    <span className="close" onClick={() => setIsOpen(false)}>
                        &times;
                    </span>

                    <button className="prev" onClick={(e) => { e.stopPropagation(); prev(); }}>
                        ❮
                    </button>

                    <img
                        className="modal-img"
                        src={`/${images[current]}.jpg`}
                        alt=""
                        onClick={(e) => e.stopPropagation()}
                    />

                    <button className="next" onClick={(e) => { e.stopPropagation(); next(); }}>
                        ❯
                    </button>
                </div>
            )}
        </>
    );
};
export default Gallery;
